import React from 'react';
import { MetaPixel } from './components/MetaPixel';
import { PurchasePopup } from './components/PurchasePopup';
import { FloatingCTA } from './components/FloatingCTA';
import { Hero } from './components/sections/Hero';
import { SocialProof } from './components/sections/SocialProof';
import { Problem } from './components/sections/Problem';
import { Presenting } from './components/sections/Presenting';
import { Systems } from './components/sections/Systems';
import { Bonuses } from './components/sections/Bonuses';
import { Offer } from './components/sections/Offer';
import { Guarantee } from './components/sections/Guarantee';
import { Testimonials } from './components/sections/Testimonials';
import { Faq } from './components/sections/Faq';
import { TwoChoices } from './components/sections/TwoChoices';
import { FinalCta } from './components/sections/FinalCta';
import { Footer } from './components/Footer';
export function App() {
  return <div className="w-full min-h-screen overflow-x-hidden bg-navy-950 font-sans text-white antialiased" data-id="element-0" data-mp="23ut9zyugts8o">
      <MetaPixel data-id="element-1" data-mp="3ijpc2xoqyt86" />
      <PurchasePopup data-id="element-2" data-mp="3ii4s22026sok" />
      <FloatingCTA triggerId="hero-cta" data-id="element-3" data-mp="3mlaxj7fckftz" />

      <Hero data-id="element-4" data-mp="3mjzsl4a6121a" />
      <main data-id="element-5" data-mp="3mjq3rk0ux0x6">
        <SocialProof data-id="element-6" data-mp="3mj6ipufwtwex" />
        <Problem data-id="element-7" data-mp="3rcj7c4kla37o" />
        <Presenting data-id="element-8" data-mp="3rbzo8kj7d8s2" />
        <Systems data-id="element-9" data-mp="3rdkl4gszp3t3" />
        <Bonuses data-id="element-10" data-mp="3rd189ei755lx" />
        <Offer data-id="element-11" data-mp="3relwynhtxubv" />
        <Guarantee data-id="element-12" data-mp="5orv1p50w72" />
        <Testimonials data-id="element-13" data-mp="682dxcgkib2" />
        <Faq data-id="element-14" data-mp="5gfdawxfswe" />
        <TwoChoices data-id="element-15" data-mp="56qxrrj5tst" />
        <FinalCta data-id="element-16" data-mp="2zl3alhpbj03q" />
      </main>
      <Footer data-id="element-17" data-mp="2zlv7qwykd5w4" />
    </div>;
}